import { MfModelBase, MfModelConfig, MfModelFieldConfig, MfModelFieldDataTypes } from "@pattonair/material-framework";


export type AucUserApprovedModel = MfModelBase & {
  active: boolean;
}

export type AucUserApprovedModelFieldsConfig = {
  [key in keyof Required<AucUserApprovedModel>]: MfModelFieldConfig
};

export const AUC_USER_APPROVED_MODEL_FIELDS_CONFIG: AucUserApprovedModelFieldsConfig = {
  active: {
    dataType: {
      type: MfModelFieldDataTypes.boolean,
    }
  }
};

export const AUC_USER_APPROVED_MODEL_CONFIG_ID = "userApproved";

export const AUC_USER_APPROVED_MODEL_CONFIG: MfModelConfig = {
  key: AUC_USER_APPROVED_MODEL_CONFIG_ID,
  fields: AUC_USER_APPROVED_MODEL_FIELDS_CONFIG,
  autoMapping: {
    constName: "AUC_USER_APPROVED_MODEL_CONFIG",
  },
  portals: {}
};